export default __webpack_public_path__ + "static/media/流浪救助勋章.39cfdf88.png";